var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"white-box selects",attrs:{"align-self":"center"}},[_c('div',{staticClass:"d-flex w-100"},[_vm._t("image"),_vm._t("options")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }